import PropTypes from 'prop-types';
import { Icon, USER_INTERFACE_CROSS_CANCEL } from '@bwoty-web/styleguide';

const FilterBadge = ({
  displayName,
  canDelete,
  handleDelete,
  item,
  handleIndicateFilters,
}) => {
  // TODO: "item" looks like it is needed, but is not passed from anywhere. I guess its not needed anymore?
  return (
    <div
      onClick={!canDelete ? handleIndicateFilters : () => {}}
      role="button"
      tabIndex="0"
      onKeyDown={(e) => {
        if (e.keycode === 13 && !canDelete) {
          handleIndicateFilters();
        }
      }}
      className="vf-selected-filters-panel__badge"
    >
      <span className="vf-selected-filters-panel__badge__label">
        {displayName}
      </span>
      {canDelete && (
        <Icon
          path={USER_INTERFACE_CROSS_CANCEL}
          className="vf-selected-filters-panel__badge__close"
          role="button"
          tabIndex="0"
          onKeyDown={(e) => {
            if (e.keycode === 13) {
              handleDelete(item);
            }
          }}
          onClick={() => handleDelete(item)}
        />
      )}
    </div>
  );
};

FilterBadge.propTypes = {
  displayName: PropTypes.string.isRequired,
  item: PropTypes.shape({}).isRequired,
  canDelete: PropTypes.bool.isRequired,
  handleDelete: PropTypes.func.isRequired,
  handleIndicateFilters: PropTypes.func.isRequired,
};

export default FilterBadge;
